import React, { FC, useContext, useEffect, useState } from "react";
import { IReportItemProps } from "../users/userReports/ReportItem";
import { dateFormat } from "../../utils";
import { $public } from "../../http";
import Button from "../../components/UI/button/GgButton";
import { DocIcon } from "../../assets/icons";
import Spinner from "../../components/UI/spinner/Spinner";

const Report: FC<IReportItemProps> = ({ data, handleReport, setReports, deletePropertyReport, actionData}) => {
  const [loading, setLoading] = useState(false);

  const statusColorLookup = {
    awaiting: "#FFC107",
    loaded: "#4CAF50",
    rejected: "#F44336",
    default: "#ffffff",
  };

  const updateUserReport = async (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      let formData = new FormData();
      formData.append("report_id", data._id);
      formData.append("file", e.target.files[0]);
      const results = await handleReport.updateReport(formData);
      if (results) {
        // @ts-ignore
        setReports(results);
      }
    }
  };

  const downloadPropertyReport = async () => {
    let link = document.createElement("a");
    link.target = "_blank";
    link.href = $public(`client/account/documents/download${data?.documents}`);
    link.click();
    link.remove();
  };

  // const deletePropertyReport = async (id: any) => {
  //   try {
  //     if (window.confirm("Are you sure you want to delete this Property Report?")) {
  //       await handleReport.deleteReport(id).then(() => {
  //         handleReport.loadReports().then((res: any) => {
  //           console.log(res)
  //           showSuccessToast("Property Report Deleted successfully !")
  //         })
  //       })
  //     }
  //    } catch (error) {
  //     console.log(error)
  //    }
  // }

  return (
    <>
    {!loading ? 
    <div className="card">
    <div className="card-info">
      <div className="card-title status">
        <div className="image-box">
          <div className="piece image">
            <img
              loading="lazy"
              src={$public(data?.client?.photo)}
              alt="user_image"
            />
          </div>
          <div className="piece">{data?.client?.name}</div>
        </div>
        <span
          className="piece"
          style={{
            backgroundColor: statusColorLookup[data?.status || "default"],
          }}
        >
          {data?.status === "loaded" ? "Replied" : data?.status}
        </span>
      </div>
      <div className="card-title">
        <span className="piece">{data?.address}</span>
      </div>
      <div className="content">
        <span className="piece">
          Created: {dateFormat(data?.created_at)} /{" "}
        </span>
        <span className="piece">Updated: {dateFormat(data?.updated_at)}</span>
      </div>
    </div>
    <div className="controls" style={{display:"flex", justifyContent:"space-between"}}>
      {actionData?.delete ? (
        <Button label="Delete" stylesType="border" onPress={() => deletePropertyReport(data?._id)}/>
      ): ""}
      {data?.status !== "loaded" && (
        <label className="upload">
          <input type="file" onChange={updateUserReport} />
          <span className="file-button-label">Reply</span>
        </label>
      )}
      {data?.status === "loaded" && (
        <abbr title="Download Report">
          <Button
            icon={{ leftIcon: <DocIcon /> }}
            stylesType="round"
            className="download-btn"
            onPress={downloadPropertyReport}
          />
        </abbr>
      )}
    </div>
  </div>
  : <Spinner />}
    </>
  );
};

export default Report;